import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { DataListParams, DataListProp, LayoutProps } from "../../layoutType";
import { FormInstance } from "antd";
import { getMatchingSelectData, runFormFunction } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { equipClipboard } from "../../inputCols/clipboard";
import { enLocale } from "@/i18n/routing";
export const CafeMenu = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;

  const utcOffset = dayjs().utcOffset() * 60000;
  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_cafe","system_TABLE_NAME":"menu_default","system_table_pk":["cafe_seq","menu_seq"],"system_table_manual_increment":"menu_seq","system_table_page":"CafeMenu","system_table_path":"cafe/menu/default","system_table_page_name":"CafeMenu","system_table_auth":["USER"],"system_select_auth":["cafe"],"system_table_mapper":"cafemenu","system_table_detail_result":"detail_result","system_table_search_column":[],"system_table_search_select":["menu_name","menu_name_locale"],"system_table_order_column":["menu_name_locale"],"system_table_default_name_column":"menu_name_locale","system_table_en_name_column":"menu_name","system_table_use_column":"menu_use"},
    //--info--"change":{"cafe_seq":{"CHECK_LIST":["LIST","READ","CREATE"]},"menu_seq":{"CHECK_LIST":["LIST","READ","CREATE"]},"coffeebean_seq":{"CHECK_LIST":["READ","CREATE","UPDATE","EXCEL_IN","EXCEL_UP"]},"brewing_seq":{"CHECK_LIST":["READ","CREATE","UPDATE","EXCEL_IN","EXCEL_UP"]}}
    //--info--}
    case "CafeMenuDefault":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/cafe/menu/default/detail/",
          saveFetch: { fetchUrl: "/api/cafe/menu/default/edit" },
        },
        listFetch: { fetchUrl: "/api/cafe/menu/default/list" },
        dataResultName: "detail_result",
        dataName: "CafeMenuData",
        dataCols: {
          menu_name_locale: {
            ...dc.inputFull,
            minLength: params?.locale !== enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: params?.locale !== enLocale ? dc.strongLabelClassName : undefined,
            order: params?.locale !== enLocale ? 1 : 2,
            required: params?.locale !== enLocale ? true : undefined,
          },
          menu_name: {
            ...dc.inputFull,
            minLength: params?.locale === enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: params?.locale === enLocale ? dc.strongLabelClassName : undefined,
            order: params?.locale === enLocale ? 1 : 2,
            required: params?.locale === enLocale ? true : undefined,
            read: { variant: "borderless" },
          },
          menu_coffee_use: { ...dc.use },
          coffeebean_seq: {
            ...dc.selectSearch,
            label: "use_coffeebean_label",
            inputClassName: dc.greenbeanSeqWidth,
            dataUrl: "/api/cafe/coffeebean/default/code",
            dataProp: {
              load: (data, select_data) => {
                Debug(data, select_data);
              },
            },
            widthFull: true,
            dataLabel: {
              value: "coffeebean_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "coffeebean_name", subs: "coffeebean_nick" }
                  : { field: "coffeebean_name_locale", subs: "coffeebean_nick_locale" },
              ],
              labelSort: true,
            },
            onChange: (data) => {},
            create: { dataProp: { firstReload: true } },
            read: { display: "notNull" },
            tooltip: true,
            tooltipTransition: false,
          },
          brewing_seq: {
            ...dc.brewingSelect(params?.locale, false),
            label: "brewing_info",
            dataUrl: "/api/cafe/brewing/default/code",
            // dataProp: {
            //   load: (data, select_data) => {
            //     Debug(data, select_data);
            //   },
            // },
            read: { display: "notNull" },
            tooltip: true,
            tooltipTransition: false,
          },
          menu_desc: { ...dc.textAreaM, maxLength: 3000 },
          menu_order: { ...dc.number },
          menu_use: { ...dc.useDefault, required: true },
          rgst_by: { ...dc.rgst },
          edit_by: { ...dc.edit },
        },
        listColLinkField: "menu_seq",
        listSearch: [
          { ...dc.listSearchUse, field: "search0", label: "menu_coffee_use", placeholder: "menu_coffee_use" },
          { ...dc.listSearchUse, field: "search1", label: "menu_use", placeholder: "menu_use" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "menu_name_locale", placeholder: "menu_name_locale" },
          // { ...dc.input, field: "search_type0", label: "menu_name", placeholder: "menu_name" },
          // { ...dc.input, field: "search_type1", label: "menu_name_locale", placeholder: "menu_name_locale" },
        ],
        listOrder: [
          "menu_order_orderasc",
          "menu_order_orderdesc",
          "menu_name_locale_orderasc",
          "menu_name_locale_orderdesc",
          "menu_coffee_use_orderasc",
          "menu_coffee_use_orderdesc",
        ],
        listCols: [
          // "cafe_seq",
          //  "menu_seq",
          params?.locale === enLocale ? "menu_name" : "menu_name_locale",
          { field: "menu_coffee_use", ...dc.listUse },
          { field: "menu_use", ...dc.listUse },
          "menu_order",
        ],
      };

    default:
      return undefined;
  }
};
